import React from 'react';
import './App.css';
import { 
  BrowserRouter as Router, Routes, Route 
} from "react-router-dom";
import Login from "./Login";
import Dashboard from "./Dashboard";
import './assets/scss/style.scss'
import 'react-loading-skeleton/dist/skeleton.css'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login/>}/>
        <Route path="/" element={<Dashboard/>}/>
      </Routes>
    </Router>
  );
}

export default App;
